<template>
  <div>
    <b-navbar variant="faded" type="light" class="mb-1">
      <b-navbar-brand tag="h1">
        <img src="/img/VertiHub-Logo.svg" width="55px" alt="Logo VertiHub" class="pr-2 ml-0 pl-0">
        VertiHub Rettung erfassen <br><b-badge v-if="!showHubSelection && hubName">{{ hubName }}</b-badge>
      </b-navbar-brand>
    </b-navbar>
    <b-alert show=10 fade dismissible dismiss-label="Hinweis ausblenden" @dismissed="showSuccessAlert = false"
      variant="success" v-if="showSuccessAlert">
      <b-icon icon="check-square-fill" variant="success"></b-icon> Rettung wurde erfolgreich gespeichert!
    </b-alert>
    <b-alert show fade dismissible dismiss-label="Hinweis ausblenden" @dismissed="showErrorAlert = false" variant="danger"
      v-if="showErrorAlert">
      <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon> Fehler beim Speichern der Rettung!
    </b-alert>
    <b-alert show fade dismissible dismiss-label="Warnung ausblenden" @dismissed="showScrewWarning = false" variant="warning"
      v-if="showScrewWarning">
      <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon> Bitte bestätigen, dass die Rolle wieder mit 17Nm verschlossen wurde!
    </b-alert>
    <b-overlay :show="loading" rounded="sm" spinner-type="grow" spinner-variant="success">
      <b-form @submit="onSubmit" @reset="onReset" v-if="showForm">
        <b-form-group id="select-kletterwald-group" label="Kletterwald:" label-for="select-kletterwald"
          v-if="showLocationSelection">
          <b-form-select id="select-kletterwald" v-model="location" :options="locations" required
            @input="loadData()"></b-form-select>
        </b-form-group>

        <b-form-group id="select-hub-group" label="Abseil-Gerät:" label-for="select-hub" v-if="showHubSelection">
          <b-form-select id="select-hub" v-model="hub" :options="hubs" required
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'" @change="updateHubName($event)"></b-form-select>
        </b-form-group>

        <b-form-group id="select-parcours-group" label="Parcours:" label-for="select-parcours">
          <b-form-select id="select-parcours" v-model="form.parcours" :options="parcours" required
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'" @change="updateHeight($event)"></b-form-select>
        </b-form-group>

        <b-form-group id="spin-abseilmeter-group" label="Abseilmeter (m):" label-for="spin-abseilmeter">
          <b-form-spinbutton id="spin-abseilmeter" v-model="form.abseilmeter" min="1" max="50" required
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'"></b-form-spinbutton>
        </b-form-group>

        <b-form-group id="spin-hubmeter-group" label="Hubmeter (m):" label-for="spin-hubmeter">
          <b-form-spinbutton id="spin-hubmeter" v-model="form.hubmeter" min="0" max="1" step="0.1" locale="de" required
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'"></b-form-spinbutton>
        </b-form-group>

        <b-form-group id="select-trainer-group" label="Trainer:" label-for="select-trainer">
          <b-form-select id="select-trainer" v-model="form.trainer" :options="trainer" required
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'">
          </b-form-select>
        </b-form-group>

        <b-form-group id="text-anmerkung-group" label="Anmerkungen zur Rettung (optional):" label-for="text-anmerkung">
          <b-form-textarea id="text-anmerkung" v-model="form.anmerkung"
            placeholder="Anmerkungen zur Rettung (Element, Besonderheiten...)" rows="3" max-rows="6"
            :disabled="location != 'DA' && location != 'NB' && location != 'FRA'"></b-form-textarea>
        </b-form-group>

        <b-form-group id="checkbox-screw-group" v-if="location == 'NB'">
          <b-form-checkbox value="checked" unchecked-value="not_checked" v-model="form.screw" size="lg"
            id="checkbox-screw"><span style="color: red"><b>Rolle wurde wieder mit 17 Nm verschlossen.</b></span></b-form-checkbox>
        </b-form-group>

        <b-form-group id="checkbox-training-group">
          <b-form-checkbox value="training" unchecked-value="no_training" v-model="form.training" size="lg"
            id="checkbox-training">Übung</b-form-checkbox>
          <b-form-checkbox value="aktivrettung" unchecked-value="no_aktivrettung" v-model="form.aktivrettung" size="lg"
            id="checkbox-aktivrettung">Aktivrettung <small class="text-muted">(doppelte Personenlast)</small></b-form-checkbox>
        </b-form-group>

        <div class="row pt-4 mb-2">
          <div class="col">
            <b-button type="reset" block size="lg" variant="warning">Abbrechen</b-button>
          </div>
          <div class="col">
            <b-button type="submit" block size="lg" variant="success" :disabled="location == 'NB' && form.screw == 'not_checked'">Speichern</b-button>
          </div>
        </div>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import { db } from "../firebaseDb";
import firebase from 'firebase/compat/app'
export default {
  name: 'RettungEintragen',
  props: {

  },
  data() {
    return {
      form: {
        parcours: '',
        trainer: '',
        abseilmeter: 1,
        hubmeter: 0,
        anmerkung: '',
        training: 'no_training',
        screw: 'not_checked',
        aktivrettung: 'no_aktivrettung'
      },
      locations: [{ value: 'DA', text: 'Demo Kletterwald' }],
      hubs: [],
      parcours: [],
      parcoursHeights: [],
      trainer: [],
      location: '',
      hub: '',
      hubName: '',
      showForm: true,
      showSuccessAlert: false,
      showErrorAlert: false,
      showScrewWarning: false,
      showLocationSelection: true,
      showHubSelection: true,
      loading: false,
    }
  },
  mounted() {
    let params = new URLSearchParams(document.location.search);
    const locParam = params.get("location")
    if (locParam) {
      this.location = locParam.toUpperCase();
      if (this.location == 'DA' || this.location == 'NB' || this.location == 'FRA') {
        this.showLocationSelection = false
        this.loadData()
      }
    }
    const hubParam = params.get("hub")
    if (hubParam) {
      this.hub = hubParam.toLowerCase()
      this.showHubSelection = false
    }
  },
  created() {
  },
  methods: {
    loadData() {
      this.loading = true
      this.getParcours(this.location)
      this.getHubs(this.location)
      this.getTrainer(this.location)
      this.loading = false
    },
    getParcours(loc) {
      const parcoursRef = db.collection("parcours");
      parcoursRef.where('locationID', '==', loc).orderBy("position").onSnapshot((snapshotChange) => {
        this.parcours = [];
        snapshotChange.forEach((doc) => {
          this.parcoursHeights.push({
            name: doc.data().Name,
            height: doc.data().height || 0,
          });
          this.parcours.push(doc.data().Name);
        });
      })
    },
    getHubs(loc) {
      const hubsRef = db.collection("hubs");
      hubsRef.where('locationID', '==', loc).onSnapshot((snapshotChange) => {
        this.hubs = [];
        snapshotChange.forEach((doc) => {
          if (this.hub && this.hub == doc.id) {
            this.hubName = doc.data().name
          }
          this.hubs.push({
            value: doc.id,
            text: doc.data().name,
          });
        });
        this.loading = false
      })
    },
    getTrainer(loc) {
      const trainerRef = db.collection('trainer')
      trainerRef.where('locationID', 'array-contains', loc).where('isToday', '==', true).where('isTodayLocation', '==', loc).orderBy('Name').onSnapshot((snapshotChange) => {
        this.trainer = []
        snapshotChange.forEach((doc) => {
          this.trainer.push(doc.data().Name)
        })
      })
    },
    updateHeight(parc) {
      const height = this.parcoursHeights.find(p => p.name === parc).height
      if (height) {
        this.form.abseilmeter = height
      }
    },
    updateHubName(hub) {
      const hubname = this.hubs.find(h => h.value === hub).text
      if (hubname) {
        this.hubName = hubname
      }
    },
    onSubmit(event) {
      event.preventDefault()
      if (this.form.parcours && this.form.trainer && this.form.abseilmeter && this.hubName) {
        if(this.location == 'DA' || this.location == 'FRA' || (this.location == 'NB' && this.form.screw == "checked")) {
          let screwChecked = true
        
        let isTraining = false
        if (this.form.training == "training") {
          isTraining = true
        }
        let isAktivrettung = false
        if (this.form.aktivrettung == "aktivrettung") {
          isAktivrettung = true
        }
        var batch = db.batch()
        const hubsRef = db.collection('hubs')
        const rescuesRef = db.collection('rescues')

        const rescueId = rescuesRef.doc().id;
        batch.set(rescuesRef.doc(rescueId), {
          DateTime: new Date(),
          Parcours: this.form.parcours,
          Hub: this.hubName,
          HubId: this.hub,
          Down: this.form.abseilmeter,
          Up: this.form.hubmeter,
          Trainer: this.form.trainer,
          Training: isTraining,
          Aktivrettung: isAktivrettung,
          Note: this.form.anmerkung,
          Screw: screwChecked,
          locationID: this.location,
        })
        if (isAktivrettung == true) {
          batch.update(hubsRef.doc(this.hub), {
            rescueAktivCount: firebase.firestore.FieldValue.increment(1),
            metersDown: firebase.firestore.FieldValue.increment(this.form.abseilmeter),
            metersUp: firebase.firestore.FieldValue.increment(this.form.hubmeter)
          })
        } else {
          batch.update(hubsRef.doc(this.hub), {
            rescueCount: firebase.firestore.FieldValue.increment(1),
            metersDown: firebase.firestore.FieldValue.increment(this.form.abseilmeter),
            metersUp: firebase.firestore.FieldValue.increment(this.form.hubmeter)
          })
        }

        batch.commit().then(() => {
          this.form.parcours = ''
          this.form.trainer = ''
          this.form.abseilmeter = 1
          this.form.hubmeter = 0
          this.form.anmerkung = ''
          this.form.training = 'no_training',
          this.form.aktivrettung = 'no_aktivrettung',
          this.form.screw = 'not_checked',
          this.showSuccessAlert = true
        }).catch((e) => {
          this.showErrorAlert = true
          this.showSuccessAlert = false
          console.log("Error adding rescue: " + e)
        })
      } else {
        this.showScrewWarning = true
      }
    }
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.parcours = ''
      this.form.trainer = ''
      this.form.abseilmeter = 1
      this.form.hubmeter = 0
      this.form.anmerkung = ''
      this.form.training = 'no_training',
      this.form.aktivrettung = 'no_aktivrettung',
      this.form.screw = 'not_checked',
      // Trick to reset/clear native browser form validation state
      this.showForm = false
      this.$nextTick(() => {
        this.showForm = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
